<template>
  <div class="text-center px-4 py-8">
    <h2 class="text-2xl text-white-1">{{ $t('attachments.skip_modal.title') }}</h2>

    <p class="font-light mt-3">{{ $t('attachments.skip_modal.message') }}</p>

    <div class="mt-10">
      <Button :label="$t('attachments.skip_modal.cancel')" @click="cancel" />

      <Button class="ml-4" color="btn-primary-outline" :label="$t('attachments.skip_modal.confirm')" @click="confirm" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'AttachmentsSkipModal',
  components: { Button },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
